import _toConsumableArray from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jsd/github/quantastic/quantastic-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
import * as React from 'react';
import withIntl from './injectIntl';

var shallowEquals = require('shallow-equal/objects');

import { formatMessage as baseFormatMessage } from '../format';
import { invariantIntlContext, DEFAULT_INTL_CONFIG, createDefaultFormatters } from '../utils';

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }

  return baseFormatMessage(Object.assign({}, DEFAULT_INTL_CONFIG, {
    locale: 'en'
  }), createDefaultFormatters(), descriptor, values);
};

export var BaseFormattedMessage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseFormattedMessage, _React$Component);

  function BaseFormattedMessage(props) {
    var _this;

    _classCallCheck(this, BaseFormattedMessage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseFormattedMessage).call(this, props));

    if (!props.defaultMessage) {
      invariantIntlContext(props);
    }

    return _this;
  }

  _createClass(BaseFormattedMessage, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;

      if (!shallowEquals(nextValues, values)) {
        return true;
      } // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.


      var nextPropsToCheck = Object.assign({}, nextProps, {
        values: values
      });
      return !shallowEquals(this.props, nextPropsToCheck);
    }
  }, {
    key: "render",
    value: function render() {
      var _ref = this.props.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage = _ref$formatMessage === void 0 ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === void 0 ? React.Fragment : _ref$textComponent;

      var _this$props = this.props,
          id = _this$props.id,
          description = _this$props.description,
          defaultMessage = _this$props.defaultMessage,
          values = _this$props.values,
          _this$props$tagName = _this$props.tagName,
          Component = _this$props$tagName === void 0 ? Text : _this$props$tagName,
          children = _this$props.children;
      var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
      };
      var nodes = formatMessage(descriptor, values);

      if (!Array.isArray(nodes)) {
        nodes = [nodes];
      }

      if (typeof children === 'function') {
        return children.apply(void 0, _toConsumableArray(nodes));
      }

      if (Component) {
        // Needs to use `createElement()` instead of JSX, otherwise React will
        // warn about a missing `key` prop with rich-text message formatting.
        return React.createElement.apply(React, [Component, null].concat(_toConsumableArray(nodes)));
      }

      return nodes;
    }
  }]);

  return BaseFormattedMessage;
}(React.Component);
BaseFormattedMessage.defaultProps = {
  values: {}
};
export default withIntl(BaseFormattedMessage, {
  enforceContext: false
});